import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash"
import {Empty, Modal, notification} from "antd";
import
{
	Button,
	Loading,
	Icon
} from "~/components";
import ActionBar from "~/layout/ActionBar";
import
{
	handleRequest,
	apiError,
} from "~/utils";
import
{
	useCan
} from "~/hooks";
import
{
	supplierApi
} from "~/api";
import {
	SupplierSearchBar,
	SupplierTable,
	SupplierFormAddEdit,
} from "../components";
import {
	supplierActions,
	supplierErrorSelector,
	supplierFilterSelector,
	supplierItemsSelector,
	supplierLoadingSelector,
	supplierPaginationSelector
} from "../../../reduxs/Supplier/supplierSlice";


function Supplier()
{
	const can = {
	    add : useCan('supplier_add'),
	    edit : useCan('supplier_edit'),
	    delete : useCan('supplier_delete')
	}

	const dispatch  = useDispatch();

	const items     = useSelector(supplierItemsSelector);

	const loading   = useSelector(supplierLoadingSelector);

	const error     = useSelector(supplierErrorSelector);

	const pagination = useSelector(supplierPaginationSelector);

	const filter    = useSelector(supplierFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	//Model
	const [openModal, setOpenModal] = useState({
		addEdit     : false,
		delete      : false,
	});

	const eventHandlers =
	{
		openModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: true }));
		}, []),

		closeModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: false }));
		}, []),

		load: useCallback(() =>
		{
			dispatch(supplierActions.fetchData(filter));
		}, [dispatch, filter]),

		paginationChange: (page) =>
		{
			dispatch(supplierActions.setFilter({...filter, page }));
		},

		search: (newFilter) =>
		{
			dispatch(supplierActions.setFilterWithDebounce(newFilter));
		},

		filterChange: (key, value) =>
		{
			const newFilter = {
				...filter,
				[key]: value,
				page: 1
			};
			dispatch(supplierActions.setFilter(newFilter));
		},

		add: async (data) =>
		{
			let [error, response] = await handleRequest(supplierApi.add(data));

			let message = apiError(`Thêm nhà cung cấp thất bại`, error, response);

			if(!message)
			{
				notification.success({message: 'Thành công', description: `Thêm nhà cung cấp thành công`});

				dispatch(supplierActions.add(response.data));

				eventHandlers.closeModal('addEdit')
			}
		},

		update: async (data, item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin nhà cung cấp để cập nhật'});
				return;
			}

			data.id = item.id;

			let [error, response] = await handleRequest(supplierApi.update(data));

			if(!apiError(`Cập nhật thông tin nhà cung cấp thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `Cập nhật thông tin nhà cung cấp thành công`});

				dispatch(supplierActions.update({
					...item,
					...response.data
				}));

				eventHandlers.closeModal('addEdit')
			}
		},

		//Delete
		delete: async () =>
		{
			if (!itemEdit?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin nhà cung cấp để xóa'});
				return;
			}

			let [error, response] = await handleRequest(supplierApi.delete(itemEdit.id));

			if(!apiError(`xóa nhà cung cấp thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `xóa nhà cung cấp thành công`});

				dispatch(supplierActions.delete(itemEdit.id));

				eventHandlers.closeModal('delete')
			}
		}
	}

	//Load data
	useEffect(() =>
	{
		let isMounted = true;
		if (isMounted) eventHandlers.load();
		return () => { isMounted = false };
	}, [filter]);

	return (
		<>
			<ActionBar title={'Nhà cung cấp'}>
				{can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({}); eventHandlers.openModal('addEdit')}}>Thêm mới</Button>}
				<Button outline onClick={eventHandlers.load}>{Icon.reload}</Button>
			</ActionBar>
			<div className="container">
				<div className="content p-2">
					{loading && <Loading/>}
					{<SupplierSearchBar filter={filter} onSearchChange={eventHandlers.search} onChange={eventHandlers.filterChange} can={can} />}
					{_.isEmpty(items) && <Empty />}
					{!_.isEmpty(items) && <SupplierTable
							items={items}
							pagination={pagination}
							onPaginationChange={eventHandlers.paginationChange}
							setItemEdit={setItemEdit}
							openModal={eventHandlers.openModal}
							can={can}
					/>}
				</div>
				{
					(can.add || can.edit) && <Modal
						title="Nhà Cung Cấp"
						centered
						width={1000}
						open={openModal.addEdit}
						onCancel={() => {eventHandlers.closeModal('addEdit')}}
						footer={null}
					>
						<SupplierFormAddEdit item={itemEdit}
											 onAdd={eventHandlers.add}
											 onUpdate={eventHandlers.update}
						/>
					</Modal>
				}
				{
					(can.delete && itemEdit?.id) && <Modal
						title="Xóa nhà cung cấp"
						open={openModal.delete}
						onOk={eventHandlers.delete}
						okType={'danger'}
						onCancel={() => {eventHandlers.closeModal('delete')}
					}>
						<p>Bạn muốn xóa nhà cung cấp <b>{itemEdit?.name}</b>?</p>
					</Modal>
				}
			</div>
		</>
	)
}

export default Supplier;